module.exports = __webpack_public_path__ + "img/pc-button-large-01.f64fec1b.svg";